module.exports = __webpack_public_path__ + "static/media/IsraarKhan.2cf9862e.jpeg";